import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '@mui/icons-material/Close';
import useBreakpointView from 'utils/useBreakpointView';
import Text from 'components/Core/Text';
import HyperLink from 'components/Core/HyperLink';
import RichText from 'components/RichText';
import Banner from '..';
import { DetailsContainer } from './styles';

const PromoBar = ({ desktopPromoCopy, mobilePromoCopy, promoDetails }) => {
  const [showDetails, toggleDetails] = useState(false);
  const isMobile = useBreakpointView(['xs', 'sm']);
  const bodyRef = useRef();
  const details = promoDetails?.components[0];

  useEffect(() => {
    bodyRef.current = document.body;
  }, []);

  useEffect(() => {
    document.body.style.overflow = showDetails ? 'hidden' : 'auto';
  }, [showDetails]);

  return (
    <>
      <Banner className="website-header--promo-bar bg-darkest z-10 relative">
        <div
          className={`py-[15px] px-[20px] flex mx-auto my-0 sm:justify-center ${
            promoDetails ? 'justify-between' : 'justify-center'
          }`}
        >
          <Text
            type="p"
            size="small"
            className="!leading-100p font-extrabold !text-white mb-0 !w-fit"
          >
            {isMobile && mobilePromoCopy ? mobilePromoCopy : desktopPromoCopy}{' '}
          </Text>
          {details &&
            (details?.__typename === 'ContentfulCallToAction' ? (
              <HyperLink href={details.url || '#'}>
                <Text
                  type="p"
                  size="small"
                  className="!leading-100p font-extrabold underline !text-white mb-0 !w-fit"
                >
                  {details.buttonLabel || 'Details'}
                </Text>
              </HyperLink>
            ) : (
              (details?.__typename === 'ContentfulRichText' && details.content.raw && (
                <Text
                  type="p"
                  size="small"
                  className="!leading-100p cursor-pointer font-extrabold underline !text-white mb-0 !w-fit"
                  onClick={() => toggleDetails(!showDetails)}
                >
                  Details
                </Text>
              )) ||
              null
            ))}
        </div>
      </Banner>
      {details?.__typename === 'ContentfulRichText' &&
        details.content.raw &&
        bodyRef.current &&
        createPortal(
          <>
            {!isMobile && (
              <div
                className={`promo-details-overlay fixed w-screen h-screen top-0 left-0 right-0 bottom-0 bg-black z-modal-overlay cursor-pointer transition-all duration-500 ease-in-out ${
                  showDetails ? 'opacity-80 visible' : 'invisible opacity-0'
                }`}
                onClick={() => toggleDetails(false)}
              />
            )}
            <div
              className={`promo-details--container bg-white fixed flex flex-col p-8 top-0 right-0 w-1/3 min-w-[510px] max-w-full h-[100dvh] transition-all duration-500 ease-in-out ${
                showDetails ? 'right-0' : 'right-[-100%]'
              } ${
                isMobile ? 'z-max' : 'z-modal'
              } sm-max:min-w-full sm-max:w-full sm-max:bg-darkest sm-max:px-[20px] sm-max:py-[15px]`}
            >
              <CloseIcon
                className="mobile-menu--close-icon cursor-pointer min-sm"
                sx={{
                  marginLeft: 'auto',
                  marginBottom: '16px',
                  width: '40px',
                  height: '40px',
                }}
                onClick={() => toggleDetails(false)}
              />
              <Text
                type="p"
                size="small"
                className="mb-9 ml-auto font-extrabold flex justify-end w-fit text-white underline max-sm"
                onClick={() => toggleDetails(false)}
              >
                Close
              </Text>
              <DetailsContainer className="promo-details overflow-y-auto sm-max:max-h-[calc(100%-145px)]">
                <RichText content={details.content} />
              </DetailsContainer>
            </div>
          </>,
          bodyRef.current,
        )}
    </>
  );
};

export default PromoBar;
